export default class DtoSurveyParam {
    constructor(obj) {
        this.idSurvey = obj.idSurvey // Long,
        this.parameter = obj.parameter // String,
        this.value = obj.value // Option[String],
        this.updateDate = obj.updateDate // Option[DateTime] = None,
        this.updateLogin = obj.updateLogin // Option[String] = None
    }
}